import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Box, NakedButton } from '@qga/roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

export const MessageContainer = styled(Box)`
  background-color: ${themeGet('colors.white')};
  border-radius: ${themeGet('radii.default')};
  box-shadow: ${themeGet('shadows.default')};
`;

export const RemoveFilterButton = styled(NakedButton)`
  background-color: ${themeGet('colors.white')};
  padding: ${themeGet('space.1')} ${themeGet('space.4')};
  margin: 0 ${themeGet('space.2')} ${themeGet('space.2')} 0;
  border: ${themeGet('borders.2')} ${themeGet('colors.greys.alto')};
  border-radius: ${themeGet('radii.rounded')};
  justify-content: center;
  white-space: nowrap;

  ${mediaQuery.minWidth.md} {
    margin-bottom: ${themeGet('space.3')};
  }

  &:hover,
  &:focus {
    border-color: ${themeGet('colors.brand.primary')};
    color: ${themeGet('colors.brand.primary')};
  }
`;

export const ResetFilterLinkButton = styled(NakedButton)`
  color: ${themeGet('colors.brand.primary')};
  text-decoration: underline;
  display: block;
`;
